import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from "@angular/core";

import { switchMap } from "rxjs/operators";

import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";

import { WebComponentInitializerService } from "../shared/web-component-initializer.service";
import { DffedbEBoksTilmeldService } from "./dffedb-e-boks-tilmeld.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { EBoksTilmeldingComponent } from "../../../../common/src/lib/e-boks/e-boks-tilmelding/e-boks-tilmelding/e-boks-tilmelding.component";

@Component({
    templateUrl: "./dffedb-e-boks-tilmeld.component.html",
    styleUrls: ["./dffedb-e-boks-tilmeld.component.scss"],
    imports: [MatProgressSpinner, EBoksTilmeldingComponent],
    selector: "dffedb-e-boks-tilmeld",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DffedbEBoksTilmeldComponent implements OnInit {
    public initialiserer = true;
    @HostBinding("class.mat-app-background") public classMatAppBackground = true;
    @Input() public nodeId: number;

    constructor(
        private readonly webComponentInitializer: WebComponentInitializerService,
        private readonly umbracoIndstillingerObserver: UmbracoIndstillingerObserver,
        private readonly eBoksTilmeldService: DffedbEBoksTilmeldService,
        private readonly cdr: ChangeDetectorRef
    ) {}

    public ngOnInit(): void {
        this.webComponentInitializer
            .init(this.nodeId)
            .pipe(
                switchMap(() => this.umbracoIndstillingerObserver.valueChanges),
                switchMap(() => this.eBoksTilmeldService.skalRedirecteTilEforsyning())
            )
            .subscribe({
                next: (skalRedirecteTilEforsyning) => {
                    if (skalRedirecteTilEforsyning) {
                        this.eBoksTilmeldService.redirecTilEforsyning();
                    } else {
                        this.initialiserer = false;
                        this.cdr.markForCheck();
                    }
                }
            });
    }
}
